module.exports = __webpack_public_path__ + "static/media/invite-now.482a435f.png";